export default __webpack_public_path__ + "static/sublimation3-d1827c5c0f20c4c657969ec2695a397e.jpg";